import { useLocation } from 'react-router-dom';

import useEventTracker from 'app/hooks/useEventTracker';
import useSelectedPharmacy from 'app/hooks/useSelectedPharmacy';
import { PLUS_UPGRADE_EVENTS, type PlusUpsellSource } from 'app/tracking';

type PlusUpgradeEvent = (typeof PLUS_UPGRADE_EVENTS)[keyof typeof PLUS_UPGRADE_EVENTS];

type TrackPlusUpgrade = (
  event: PlusUpgradeEvent,
  source: PlusUpsellSource,
  alreadyRequested: boolean
) => void;

// Tracks a step of the Request Upgrade journey with the upsell it came from and the page it was on.
// The organisation goes in too: it can differ from the selected pharmacy's (the Website builder
// views one from the URL), and the events table in Redshift has no column for it.
export default function usePlusUpgradeTracker(organisationId?: string): TrackPlusUpgrade {
  const trackEvent = useEventTracker();
  const { pathname, search } = useLocation();
  const selectedPharmacy = useSelectedPharmacy();
  const orgId = organisationId ?? selectedPharmacy?.chain_id;

  return (event, source, alreadyRequested) => {
    trackEvent(event.action, {
      ...event,
      custom_params: {
        source,
        page: `${pathname}${search}`,
        already_requested: alreadyRequested,
        org_id: orgId,
      },
    });
  };
}
